import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowLeft, FiCompass } from 'react-icons/fi';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="hd-notfound container">
      <motion.div
        className="hd-notfound-content"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <span className="hd-notfound-icon"><FiCompass /></span>
        <span className="hd-notfound-eyebrow">Erreur 404</span>
        <h1 className="hd-notfound-title">Page introuvable</h1>
        <p className="hd-notfound-text">
          Le lien que vous avez suivi semble incorrect ou la page a été déplacée.
        </p>
        <Link to="/" className="hd-notfound-btn">
          <FiArrowLeft />
          <span>Retour à l'accueil</span>
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;
